// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from 'vue'
import App from './App'
import router from './router/routers'
import store from './store'
import '@/utils/mixins.js'
import 'normalize.css/normalize.css'
import '@/utils/directives'
import ElementUI from 'element-ui'
import './styles/element-variables.scss'
// global css
import './styles/index.scss'

import './assets/icons' // icon
import './router/index' // permission control
import GlobalVar from './utils/globalSettings'
import './filters'
import './directives'
promise.polyfill()

Vue.use(ElementUI)
Vue.prototype.GlobalVar = GlobalVar
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js